import { render, staticRenderFns } from "./InDistribution.vue?vue&type=template&id=20487dce&scoped=true&lang=true&"
import script from "./InDistribution.vue?vue&type=script&lang=js&"
export * from "./InDistribution.vue?vue&type=script&lang=js&"
import style0 from "./InDistribution.vue?vue&type=style&index=0&id=20487dce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20487dce",
  null
  
)

export default component.exports